module.exports = __webpack_public_path__ + "media/images/icons/vendors/large/cakes-13bdb75e1c75185b3c8d2f9d5695eb45.png";